var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8398 5.79639C17.2195 5.79639 17.5333 6.07854 17.583 6.44462L17.5898 6.54639V20.1642C17.5898 20.5784 17.2541 20.9142 16.8398 20.9142C16.4601 20.9142 16.1464 20.632 16.0967 20.2659L16.0898 20.1642V6.54639C16.0898 6.13217 16.4256 5.79639 16.8398 5.79639Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3857 15.539C20.6779 15.2454 21.1528 15.2443 21.4464 15.5366C21.7133 15.8022 21.7384 16.2188 21.5213 16.5129L21.4488 16.5972L17.3711 20.6939C17.1045 20.9616 16.6863 20.986 16.3922 20.7669L16.3079 20.6939L12.2302 16.5972C11.9379 16.3036 11.939 15.8288 12.2326 15.5366C12.4995 15.2709 12.9162 15.2477 13.2093 15.4662L13.2933 15.539L16.8391 19.101L20.3857 15.539Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91113 3.08276C7.29083 3.08276 7.60462 3.36492 7.65429 3.73099L7.66113 3.83276V17.4505C7.66113 17.8648 7.32535 18.2005 6.91113 18.2005C6.53144 18.2005 6.21764 17.9184 6.16798 17.5523L6.16113 17.4505V3.83276C6.16113 3.41855 6.49692 3.08276 6.91113 3.08276Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37972 3.30317C6.64624 3.03542 7.06449 3.01108 7.3586 3.23015L7.44283 3.30317L11.5206 7.39984C11.8128 7.69341 11.8117 8.16828 11.5182 8.4605C11.2513 8.72615 10.8346 8.74939 10.5414 8.53086L10.4575 8.45805L6.91105 4.89494L3.36505 8.45805C3.0994 8.72493 2.68279 8.7501 2.38868 8.53292L2.30439 8.4605C2.03751 8.19485 2.01234 7.77824 2.22952 7.48412L2.30194 7.39984L6.37972 3.30317Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwap);
export default __webpack_public_path__ + "static/media/Swap.b20eb675c7cfe18644b8fc3168d24fde.svg";
export { ForwardRef as ReactComponent };